import React, { JSX, useState } from 'react';

import {
  ECampaignStatusToSticker,
  TextStatusToEnum,
} from '~/src/dash/components/filters/options/campaigns';
import { ICustomRenderCellJSXProps } from '~/src/dash/components/tables/ListViewTable/common';
import {
  borderRadius,
  Col,
  Cols,
  ct,
  fontSizing,
  Row,
  Rows,
  spacing,
  Text,
  TextButton,
  TooltipWithTranslation,
} from '~/src/dash/publicaUI';

interface ICampaignStatus {
  keys: string[];
  statuses: Record<string, number>;
}

const CampaignStatus = ({ keys, statuses }: ICampaignStatus): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false);
  // Type guard: ensure statuses is a Record
  if (typeof statuses !== 'object' || statuses === null || Array.isArray(statuses)) {
    return <span>{String(statuses)}</span>;
  }

  return (
    <Rows>
      <Row noPadding>
        <Cols
          wrap
          gap={spacing.extraSmall}
          style={{
            alignItems: 'center',
            rowGap: spacing.extraSmall,
          }}
        >
          {keys.map((key, index) => {
            const { color, backgroundColor, tKey, tooltipTKey } = ECampaignStatusToSticker(
              TextStatusToEnum(key),
            );
            if (index > 1 && !isExpanded) {
              return;
            }
            return (
              <Col>
                <TooltipWithTranslation tKey={tooltipTKey}>
                  <div>
                    <Text
                      singleLineLabel
                      small
                      disableSelect
                      tKey={'ItemColonNumber'}
                      tProps={{
                        item: ct(tKey),
                        number: statuses[key],
                      }}
                      style={{
                        display: 'inline-block',
                        textAlign: 'center',
                        padding: '12px',
                        borderRadius: borderRadius.large,
                        backgroundColor,
                        color,
                      }}
                    />
                  </div>
                </TooltipWithTranslation>
              </Col>
            );
          })}
        </Cols>
      </Row>
      {keys.length > 2 && (
        <Row noPadding style={{ marginTop: spacing.extraSmall }}>
          <TextButton
            style={{ marginLeft: 'auto', fontSize: fontSizing.extraSmall }}
            onClick={() => (isExpanded ? setIsExpanded(false) : setIsExpanded(true))}
            tKey={isExpanded ? 'ShowLess' : 'ShowMore'}
          />
        </Row>
      )}
    </Rows>
  );
};

export const CampaignStatusRender = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { value } = props;
  // Type guard: ensure value is an object
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return <span>{String(value)}</span>;
  }
  // Cast as Record after type guard
  const statusObj = value as Record<string, number>;
  const keys = Object.keys(statusObj).filter((key) => {
    if (statusObj[key] > 0) {
      return true;
    }
    return false;
  });

  return <CampaignStatus keys={keys} statuses={statusObj} />;
};
